import { PRICE_FILTER_ID } from '../consts';

const getFilterValues = (filterData = []) => filterData
  .map(({ value }) => value)
  .join();

const defaultMapper = ({ id = '', value = []} = {}) => {
  return `${id}:${getFilterValues(value)}`;
}

const priceMapper = ({ id = '', value = []} = {}) => {
  const {from, to} = value[0];

  return `${id}:${from},${to}`;
}

export const mapFilters = (filters = []) => {
  return filters
    .map( filter => {
      if (filter.id === PRICE_FILTER_ID) {
        return priceMapper(filter)
      }

      return defaultMapper(filter);
    })
    .join(';');
};
